import React, { useState } from "react";
import { ProductsList } from "./List";
import { ProductsDrawer } from "./Drawer";
import { Box, Divider, Typography } from "@mui/material";

export default function ProductsPage() {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [isEditing, setIsEditing] = useState(false);

  const handleRowClick = ({ row }) => {
    setSelectedProduct(row);
    setIsEditing(true);
    setIsDrawerOpen(true);
  };

  const handleCreateNew = () => {
    setSelectedProduct(null);
    setIsEditing(false);
    setIsDrawerOpen(true);
  };

  const handleClose = () => {
    setIsDrawerOpen(false);
    setSelectedProduct(null);
    setIsEditing(false);
  };

  return (
    <Box paddingX="32px" display="flex" width="100%" justifyContent="center">
      <Box width="100%" maxWidth="1536px">
        <Typography variant="h4" component="h1" gutterBottom>
          Products
        </Typography>
        <Divider />

        <ProductsList
          onRowClick={handleRowClick}
          onCreateNew={handleCreateNew}
        />

        <ProductsDrawer
          open={isDrawerOpen}
          onClose={handleClose}
          product={selectedProduct}
          isEditing={isEditing}
        />
      </Box>
    </Box>
  );
}
